<footer class="footer">
    <div class="footer-content justify-content-between">
        <span class="m-b-0">© 2016 FINCORP JSC. ALL RIGHTS RESERVED</span>
        <!-- <span>
            <a href="#" class="text-gray m-r-15">Term &amp; Conditions</a>
            <a href="#" class="text-gray">Privacy &amp; Policy</a>
        </span> -->
    </div>
</footer>